<template>
  <div class="flex items-end justify-between">
    <div class="flex items-end gap-4">
      <InputField
        :name="`extraDeductible.options.${idx}.value`"
        :label="t('deductibleAmount')"
        type="number"
        adornment="€"
      />
      <CVButton v-if="idx" variant="danger" @click.prevent="$emit('removeOption')">{{
        t('removeOption')
      }}</CVButton>
    </div>
  </div>
  <MultipleValuesListField
    :name="`extraDeductible.options.${idx}.pricePerDay`"
    :field-settings="fieldSettings"
  />
</template>

<script lang="ts" setup>
import type { FieldSettings } from '../MultipleValuesListField.vue';
import MultipleValuesListField from '../MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import type { VehicleExtraOptionFormValues } from '@/entities/vehicle-extra.entity';
import InputField from '@/components/InputField.vue';
import CVButton from '../buttons/CVButton.vue';

defineProps<{
  idx: number;
  option: VehicleExtraOptionFormValues;
}>();

defineEmits<{
  (e: 'removeOption'): void;
}>();

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'fromDay',
    label: t('fromDay'),
    type: 'number',
    maxFractionDigits: 0,
    min: 1,
  },
  {
    name: 'pricePerDay',
    label: t('pricePerDay'),
    adornment: '€',
    type: 'number',
    maxFractionDigits: 2,
    min: 0,
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "addInclusiveExtraKmStep": "+ Add Extra Kilometers Step",
    "fromDay": "From Day",
    "pricePerDay": "Price / Day",
    "deductibleAmount": "Deductible Amount",
    "addPriceStep": "+ Add Price Step",
    "removeOption": "Remove Option"
  },
  "de": {
    "addInclusiveExtraKmStep": "+ Extrakilometerstaffelung hinzufügen",
    "fromDay": "Ab Tag",
    "pricePerDay": "Preis / Tag",
    "deductibleAmount": "SB Höhe",
    "addPriceStep": "+ Preisstaffelung hinzufügen",
    "removeOption": "Option löschen"
  },
  "es": {
    "addInclusiveExtraKmStep": "+ Añadir tramo de km adicionales",
    "fromDay": "Desde el día",
    "pricePerDay": "Precio / día",
    "deductibleAmount": "Importe de franquicia",
    "addPriceStep": "+ Añadir tramo de precio",
    "removeOption": "Quitar opción"
  }
}
</i18n>
